// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment_test = {

		name: 'test',
		override: null,
		production: false,
		api: {
			authentication: {
				url: 'https://qa.infinity.hcch.com/QARAuthentication/'
			},
			qar: {
				url: 'https://qa.infinity.hcch.com/QAR/'
			}
		},
		okta: {
			issuer: 'https://hcc-dev.oktapreview.com/oauth2/aus2n2ly7csYty0Ux0h8',
			redirectUri: 'https://qa.qarportal.tmhcc.com/implicit/callback',
			loginUri: 'https://qa.qarportal.tmhcc.com/',
			clientId: '0oa2n49gbxjxcUuQ20h8',
			pkce: true
		}
	}
;

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
